<sc-flex [fitHeight]="true" [stretchContent]="true" [vertical]="true">
  <form [formGroup]="formGroup">
    <sc-flex >
      <span>{{'add person:' | translate:
        ['tmc.personalvisit.dialog.details.additionalinformations.tab.members.add.label',
        translationService.language]}}</span>
      <sc-content-spacer></sc-content-spacer>
      <sc-string-field formControlName="firstName" [required]="true"
        [label]="'firstname' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.members.add.firstname', translationService.language]">
      </sc-string-field>
      <sc-content-spacer></sc-content-spacer>
      <sc-string-field formControlName="name" [required]="true"
        [label]="'name' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.members.add.name', translationService.language]">
      </sc-string-field>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="addMember()" [disabled]="!formGroup.valid">{{'Add' | translate:
        ['tmc.personalvisit.dialog.details.additionalinformations.tab.members.add.action.add',
        translationService.language]}}</button>
    </sc-flex>
  </form>
  <sc-flex-fitting-content [vertical]="true">
    <sc-scroll-pane>
      <table mat-table [dataSource]="membersDataSource" style="width: 100%;">

        <ng-container matColumnDef="hint">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.possibleDuplicate" title="Besucher wurde bereits erfasst"><i
                class="far fa-exclamation-triangle"></i></div>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{'nnn' | translate:
            ['tmc.personalvisit.dialog.details.additionalinformations.tab.members.table.col.name',
            translationService.language]}} </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="firstname">
          <th mat-header-cell *matHeaderCellDef>{{'fn' | translate:
            ['tmc.personalvisit.dialog.details.additionalinformations.tab.members.table.col.firstname',
            translationService.language]}} </th>
          <td mat-cell *matCellDef="let element"> {{element.firstname}} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element;let i = index">
            <a class="action" (click)="deleteMember(i)">
              <sc-icon iconClass="fa-trash"></sc-icon>
            </a>
          </td>
        </ng-container>
        <ng-container matColumnDef="filler" style="flex-grow: 100;">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element;let i = index">
            &nbsp;
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="this.membersTableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: this.membersTableColumns;"></tr>

      </table>
      <div *ngIf="!(visit?.members?.length !== 0)">
        <sc-padding>
          <sc-flex [centered]="true">
            {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}
          </sc-flex>
        </sc-padding>
      </div>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
</sc-flex>




<!--div class="tab-content">
  <div class="row col-4">

    <mat-form-field class="col">
      <input matInput name="members.name" [(ngModel)]="member.name" placeholder="{{}}" [readonly]="readonly">
    </mat-form-field>
    <mat-form-field class="col">
      <input matInput name="members.firstname" [(ngModel)]="member.firstname" placeholder="{{}}" [readonly]="readonly">
    </mat-form-field>
    <div class="col inline-block last">

    </div>
  </div>
  <div class="row">
    <h5>{{'Registered members' | translate:
      ['tmc.personalvisit.dialog.details.additionalinformations.tab.members.table.title',
      translationService.language]}}</h5>
    <div class="memberstable">


    </div>
  </div>
</div-->
